import { getSessionData, sessionKey } from '@/utils/storage.util'
import { jsonToStr } from '@/utils/str.util'
import { message } from 'ant-design-vue'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import axios from 'axios'

function getToken () {
  const cookies = document.cookie.split('; ')
  const cookieToken = cookies.find((cookie) => cookie.indexOf('user_token=') > -1)
  if (cookieToken) {
    return cookieToken.replace('user_token=', '')
  } 
  const sessionToken = getSessionData(sessionKey.user_token)
  if (sessionToken) {
    return sessionToken
  }
  
  return ''
}

async function getVisitorId () {
  const fp = await FingerprintJS.load();
  const res = await fp.get();
  return res.visitorId;
}

export const Config = {
  _token: '',
  _provder_id: ''
}

const Axios = axios.create({
  timeout: 5000, // 请求超时时间
  baseURL: '/'
})
Axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'

// 添加请求拦截器
Axios.interceptors.request.use(async config => {
  if (!Config._token) {
    Config._token = getToken()
  }
  if (!config.headers) {
    config.headers = {}
  }
  config.headers.common['Hash-Referer'] = location.hash
  config.headers.common['X-Token'] = getToken()
  config.headers.common['X-Device-Id'] = await getVisitorId()
  const query = jsonToStr(Config)
  config.url = config.url?.includes('?') ? config.url + '&' + query : config.url + '?' + query
  return config 
})

// 添加响应拦截器
Axios.interceptors.response.use(response => {
  if (typeof response.data?.status !== 'undefined') {
    if (response.data?.status === 0) {
      return response.data?.result
    }
    if (response.data?.result?.error) {
      message.error(response.data?.result?.error_description || response.data?.message);
      if (response.data?.result?.error === 'token_empty') {
        if (process.env.NODE_ENV === 'production') {
          location.href = '/console';
        }
      }
      if (response.data?.result?.error === 'authentication_failed') {
        if (process.env.NODE_ENV === 'production') {
          location.href = '/console';
        }
      }
    }
    return Promise.reject(response.data?.result)
  } 
  if (typeof response.data?.success !== 'undefined') {
    if (response.data?.success) {
      return response.data?.json 
    }
    message.error(response.data?.message)
    return Promise.reject(response.data)
  }
  return response.data
}, error => {
  return Promise.reject(error)
})

class http {
  static get = (url: string, params?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      Axios.request({
        url,
        params,
        method: 'get'
      }).then(res => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  }

  static post = (url: string, data?: any, headers?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      Axios.request({
        url,
        data,
        method: 'post',
        headers
      }).then(res => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

export default http;
